module.exports = __webpack_public_path__ + "img/isabelle-min.23e7e11e.png";